module.exports = __webpack_public_path__ + "static/img/img-indexnews3.509b89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-indexnews3.png
// module id = 8rIV
// module chunks = 0